import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client } from '@df/core/service/client';
import { AdvancedCommerceListingStore, AdvancedCommerceSearchStore } from '@df/module-advanced-commerce';
import { SearchViewComponentDef } from '@df/search/search-view.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { getState } from '@ngrx/signals';
import { ICmsOutletBlockComponent } from 'projects/app-default/src/app/catalog/outlet-block/icms-outlet-block.component';
import { NListing } from 'projects/app-default/src/app/catalog/ui/listing/product-listing.interface';
import { SearchBannerComponent } from 'projects/app-default/src/app/search/ui/banner/search-banner.component';
import { AdvancedCommerceProductListingComponent } from '../../listing/advanced-commerce-product-listing.component';

@Component({
    selector: 'advanced-commerce-search-view',
    templateUrl: './../../../../search/ui/search-view.html',
    standalone: true,
    imports: [ICmsOutletBlockComponent, SearchBannerComponent, TranslationModule, SizeClassDirective, NgComponentOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceSearchViewComponent extends SearchViewComponentDef {
    readonly client = inject(Client);

    readonly store = inject(AdvancedCommerceListingStore);
    readonly searchStore = inject(AdvancedCommerceSearchStore);

    constructor(changeDetectorRef: ChangeDetectorRef, activatedRoute: ActivatedRoute) {
        super(changeDetectorRef, activatedRoute);

        // hack for detect changes in signals store
        effect(() => {
            // read store changes and update template
            const _state = getState(this.store);

            changeDetectorRef.detectChanges();
        });

        effect(() => {
            // read store changes and update template
            const _state = getState(this.searchStore);

            changeDetectorRef.detectChanges();
        });
    }

    hasProductResults(): boolean {
        return !!this.result?.hasProducts;
    }

    get listingOutlet(): NListing.IOutlet {
        return {
            component: AdvancedCommerceProductListingComponent,
            inputs: { searchTerm: this.result?.term, element: 'search', result: this.result }
        };
    }

    get useKlevu() {
        return false;
    }

    get noResultsTitle(): string {
        return this.searchStore.response()?.labels?.autocomplete?.no_results?.title || `Sorry, we couldn't find any results for '%' `;
    }

    get noResultsText(): string | undefined {
        return this.searchStore
            .response()
            ?.labels?.autocomplete?.no_results?.['text']?.replace('{{ $original_term | html.escape }}', this.result?.term || '');
    }

    get resultTitle(): string {
        return "Search results for '%'";
    }
}
